<template>
	<el-card class="box-card">
		<el-breadcrumb separator="/">
			<el-breadcrumb-item v-for="(item, index) in list" :key="index" v-bind="index===0 ? { to: { path: '/' + item.path } } : {}">{{ item.name }}
			</el-breadcrumb-item>
		</el-breadcrumb>
	</el-card>
</template>

<script>
export default {
	props: {
		list: {
			require: true,
			type: Array
		}
	}
}
</script>

<style scoped>
.text {
	font-size: 16px;
}

.item {
	padding: 18px 0;
}

.box-card {
	width: 100%;
	height: 50px;
}

>>>.el-breadcrumb {
	font-size: 16px;
	margin: 0;
}

>>>.el-card__body {
	display: flex;
	align-items: center;
	height: 100%;
	padding: 0 0 0 22px;
}

>>>.el-breadcrumb__inner.is-link {
	font-weight: 500;
	color: #6C6E71;
}

>>>.el-breadcrumb__item:last-child .el-breadcrumb__inner {
	font-weight: 500;
	color: #6345D5;
}
</style>